export enum FileTypeEnum {
  Image = 'IMAGE',
  Video = 'VIDEO',
}

export enum SocketStatusEnum {
  SUCCESS = 'success',
  ERROR = 'error',
  PENDING = 'pending',
}

export type SocketData = {
  payload: {
    hash: string;
    status: SocketStatusEnum;
  };
  metaData: {
    uniqueId: string;
    messageType: string;
    senderId: string;
    threadId: string;
  };
};

export type FileType = {
  id: number;
  url: string;
  type: FileTypeEnum;
  name: string;
  key: string;
  blobFile?: File | null;
};

export type PvoMetadataType = {
  branding_id: number | null;
  branding_name: string | null;
  campaign_id: number | null;
  campaign_name: string | null;
  campaign_slot_id: number | null;
  campaign_slot_name: string | null;
  company_id: number | null;
  company_name: string | null;
  device_id: number | null;
  device_name: string | null;
  interaction_id: number | null;
  interaction_name: string | null;
};

export type PvoUserDataType = {
  first_name: string | null;
  last_name: string | null;
  email: string | null;
};

export type PVODataType = {
  id: number;
  created_at: string;
  score: number | null;
  hash: string;
  playwall_id: string;
  files: FileType[];
  upload_status: UploadStatusEnum | null;
};

export type FormDataType = {
  first_name: string;
  last_name: string;
  email: string;
  consent_one?: boolean;
  consent_two?: boolean;
  social_media_platform: string;
  social_media_username: string;
};

export enum StepsEnum {
  INITIALIZATION = 0,
  LOOK_AT_PLAY_WALL = 1,
  CAPTURED = 2,
  RESULT = 3,
}

export enum UploadStatusEnum {
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}
